import { CardValidityType } from '@core/enums/card/card-validity-type.enum';
import { CheckoutState } from '@core/enums/cart/cart-checkout-state.enum';
import { CheckoutStatus } from '@core/enums/cart/cart-checkout-status.enum';
import { CartStatus } from '@core/enums/cart/cart-status.enum';
import { EventVenueType } from '@core/enums/event/event-venue-type.enum';
import { ExternalPaymentResponse, ICartCheckoutStatus } from '@core/interfaces/cart/cart-checkout-status.interface';
import { ICartItem } from '@core/interfaces/cart/cart-item.interface';
import { ICart } from '@core/interfaces/cart/cart.interface';
import { IDiscount } from '@core/interfaces/cart/discount.interface';
import { Currency, OnlinePaymentMethod } from '@interticket/core';
import { DiscountType } from '../../enums/cart/discount-type.enum';
import { CUSTOMERS } from '../customer/customer.mock';

export const CHECKOUT_REDIRECT_PARAMETER_STRIPE: any = {
  sessionId: '365987f2-1ee0-43da-a7ce-9b5d14152848',
  publishableKey: 'd910a139-37f7-436a-a113-a7bac66a4db3',
};

const CHECKOUT_EXTERNAL_RESPONSE_SUCCESS_CIB: ExternalPaymentResponse = {
  resultCode: '00',
  resultText: 'Tranzakció elfogadva',
  authorizationNumber: '056625',
  paidAmount: 6580,
  currency: Currency.HUF,
};
const CHECKOUT_EXTERNAL_RESPONSE_FAILED_CIB: ExternalPaymentResponse = {
  resultCode: 'TO',
  resultText: 'A tranzakció időtúllépés miatt meghiúsult',
};

const CHECKOUT_STATUS_PAYMENT_METHOD_TYPE: OnlinePaymentMethod = OnlinePaymentMethod.CIB;
const CHECKOUT_STATUS_REDIRECT_PARAMETER: any = CHECKOUT_REDIRECT_PARAMETER_STRIPE;
const CHECKOUT_STATUS_EXTERNAL_RESPONSE_SUCCESS: ExternalPaymentResponse = CHECKOUT_EXTERNAL_RESPONSE_SUCCESS_CIB;
const CHECKOUT_STATUS_EXTERNAL_RESPONSE_FAILED: ExternalPaymentResponse = CHECKOUT_EXTERNAL_RESPONSE_FAILED_CIB;
const CHECKOUT_STATUS_PAYMENT_METHOD_LABEL = 'cib_payment_method_type'; // otpsimple_payment_method_type | cib_payment_method_type

export const CHECKOUT_STATUS_IN_PROGRESS: ICartCheckoutStatus = {
  cartId: '1bc5c2d2-54b0-4014-be3a-6c90be80f6d6',
  checkoutId: '8b835b9a-a140-4b57-b657-95ff86ab595c',
  customer: CUSTOMERS.results[0],
  externalPaymentId: '522cb85a-31d8-49cb-be05-ffb6079d1e80',
  externalPaymentResponse: null,
  paymentErrorMessage: 'checkout_stucked_message_public_site',
  paymentMethodLabel: CHECKOUT_STATUS_PAYMENT_METHOD_LABEL,
  paymentMethodType: CHECKOUT_STATUS_PAYMENT_METHOD_TYPE,
  redirectParameter: CHECKOUT_STATUS_REDIRECT_PARAMETER,
  redirectUrl: 'redirectUrl',
  state: CheckoutState.PAYMENT_METHOD_VERIFIED,
  status: CheckoutStatus.IN_PROGRESS,
  ticketDownloadLink: 'ticketDownloadLink',
};

export const CHECKOUT_STATUS_REDIRECT: ICartCheckoutStatus = {
  cartId: '1bc5c2d2-54b0-4014-be3a-6c90be80f6d6',
  checkoutId: 'f4ef5ed8-5153-47f2-a863-296342c9d29f',
  customer: CUSTOMERS.results[0],
  externalPaymentId: null,
  externalPaymentResponse: null,
  paymentErrorMessage: 'checkout_stucked_message_public_site',
  paymentMethodLabel: CHECKOUT_STATUS_PAYMENT_METHOD_LABEL,
  paymentMethodType: CHECKOUT_STATUS_PAYMENT_METHOD_TYPE,
  redirectParameter: CHECKOUT_STATUS_REDIRECT_PARAMETER,
  redirectUrl: 'https://payment.quickpay.net/567155eeaa2e40eba00f9af309ef8e63',
  state: CheckoutState.PAYMENT_TRANSACTION_STARTED,
  status: CheckoutStatus.IN_PROGRESS,
  ticketDownloadLink: 'ticketDownloadLink',
};

export const CHECKOUT_STATUS_SUCCEEDED: ICartCheckoutStatus = {
  cartId: '1bc5c2d2-54b0-4014-be3a-6c90be80f6d6',
  checkoutId: '5c331495-4611-4330-bad4-6baf7eeb6970',
  customer: CUSTOMERS.results[0],
  externalPaymentId: '522cb85a-31d8-49cb-be05-ffb6079d1e80',
  externalPaymentResponse: CHECKOUT_STATUS_EXTERNAL_RESPONSE_SUCCESS,
  paymentErrorMessage: 'checkout_stucked_message_public_site',
  paymentMethodLabel: CHECKOUT_STATUS_PAYMENT_METHOD_LABEL,
  paymentMethodType: CHECKOUT_STATUS_PAYMENT_METHOD_TYPE,
  redirectParameter: CHECKOUT_STATUS_REDIRECT_PARAMETER,
  redirectUrl: 'redirectUrl',
  state: CheckoutState.TICKET_GENERATED,
  status: CheckoutStatus.SUCCEEDED,
  ticketDownloadLink: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
};

export const CHECKOUT_STATUS_FAILED: ICartCheckoutStatus = {
  cartId: '1bc5c2d2-54b0-4014-be3a-6c90be80f6d6',
  checkoutId: '4b887193-c5ad-4e04-9c8f-0fa53f6335b9',
  customer: CUSTOMERS.results[0],
  externalPaymentId: '522cb85a-31d8-49cb-be05-ffb6079d1e80',
  externalPaymentResponse: CHECKOUT_STATUS_EXTERNAL_RESPONSE_FAILED,
  paymentErrorMessage: 'checkout_stucked_message_public_site',
  paymentMethodLabel: CHECKOUT_STATUS_PAYMENT_METHOD_LABEL,
  paymentMethodType: CHECKOUT_STATUS_PAYMENT_METHOD_TYPE,
  redirectParameter: CHECKOUT_STATUS_REDIRECT_PARAMETER,
  redirectUrl: 'redirectUrl',
  state: CheckoutState.CHECKOUT_FAILED,
  status: CheckoutStatus.STUCKED,
  ticketDownloadLink: 'ticketDownloadLink',
};

export const CART_ITEM: ICartItem = {
  id: 'cartItemId1',
  slotId: 'slotId',
  selectionId: 'selectionId1',
  eventId: 'event-id-1',
  priceCategoryId: 'f50abd72-6e61-4c79-8f93-39b0835b3693',
  price: 1000,
  ownerId: 'ownerId',
  eventType: EventVenueType.NORMAL,
  expiredTime: '2019-05-06T18:35:50+10:00',
};

export const GET_CART_RESPONSE: ICart = {
  id: 'cartId',
  currency: Currency.HUF,
  user: {
    sellerId: 'sellerId',
    partnerId: 'partnerId',
  },
  expiredTime: '2019-06-11T12:42:00+00:00',
  status: {
    name: CartStatus.OPENING,
    label: 'label',
  },
  cartItems: [
    CART_ITEM,
    { ...CART_ITEM },
    { ...CART_ITEM, eventId: 'eventId2' },
    { ...CART_ITEM, eventId: 'eventId2' },
    {
      id: 'car2tItemId3',
      slotId: 'slo4tId',
      selectionId: 'select5ionId3',
      eventId: 'event-id-1',
      priceCategoryId: 'd7609504-080d-48ec-b9f1-923533cf7d60',
      price: 1000,
      ownerId: 'ownerId',
      eventType: EventVenueType.NORMAL,
      expiredTime: '2019-05-06T18:35:50+10:00',
    },
    {
      id: 'cartIt1emId3',
      slotId: 'slot3Id',
      selectionId: 'select5ionId3',
      eventId: 'event-id-1',
      priceCategoryId: 'd7609504-080d-48ec-b9f1-923533cf7d60',
      price: 1000,
      ownerId: 'ownerId',
      eventType: EventVenueType.NORMAL,
      expiredTime: '2019-05-06T18:35:50+10:00',
    },
    {
      id: 'cartItemId4',
      slotId: 'slotId',
      selectionId: 'selectionId4',
      eventId: 'eventId2',
      priceCategoryId: 'd7609504-080d-48ec-b9f1-923533cf7d60',
      price: 1000,
      ownerId: 'ownerId',
      eventType: EventVenueType.NORMAL,
      expiredTime: '2019-05-06T18:35:50+10:00',
    },
  ],
  giftCardsToBuy: [
    {
      name: 'mock card',
      imageId: 'ae3b8837-eb6a-4ecf-ada4-2c62c73e3c63',
      templateId: 'ae3b8837-eb6a-4ecf-ada4-2c62c73e3c62',
      validity: {
        type: CardValidityType.EXPIRY_AFTERSALE,
        length: 90,
      },
      denominations: [
        {
          count: 1,
          totalPrice: 1000,
          unitPrice: 1000,
          currency: Currency.HUF,
          vat: '27%',
          items: [
            {
              itemId: '34da058c-a4c1-4160-82d2-fb868d82a4dd',
              price: 1000,
            },
          ],
        },
        {
          count: 2,
          totalPrice: 10000,
          unitPrice: 5000,
          currency: Currency.HUF,
          vat: '27%',
          items: [
            {
              itemId: 'ac6c9826-fd58-46a2-b69d-49208e86cd78',
              price: 5000,
            },
            {
              itemId: 'd32e0191-018b-4535-8e52-fb65d6690d48',
              price: 5000,
            },
          ],
        },
      ],
    },
  ],
  customer: CUSTOMERS.results[0],
  giftCards: [
    {
      name: 'Egycélú ajándékutalvány neve',
      availableAmount: 10000,
      vat: 27,
      amount: -4300,
      couponId: 'ABCDE12345',
    },
    {
      name: 'Többcélú ajándékutalvány neve',
      availableAmount: 12000,
      amount: -1200,
      couponId: 'ZYXWV098765',
    },
  ],
  totalAmount: 3,
  totalPrice: 9999,
};

export const CHECKOUT_STATUS_SUCCEEDED_QUEUE: ICartCheckoutStatus[] = [
  CHECKOUT_STATUS_IN_PROGRESS,
  // CHECKOUT_STATUS_IN_PROGRESS,
  // CHECKOUT_STATUS_REDIRECT,
  // CHECKOUT_STATUS_IN_PROGRESS,
  // CHECKOUT_STATUS_IN_PROGRESS,
  CHECKOUT_STATUS_SUCCEEDED,
  // CHECKOUT_STATUS_FAILED
];

const isGiftCard = true;
export const DISCOUNT_MOCK: IDiscount = {
  eventIds: ['eventId2', 'event-id-1'],
  couponId: '1213abde-c1eb-4ae1-bedb-238a73e5751a',
  discount: '99% Kedvezmény a Titanicra',
  discountType: isGiftCard ? DiscountType.GIFTCARD : DiscountType.COUPON,
  discountRemainingCount: 3,
};
